import Vue from 'vue';
import dateFormat from '@/plugins/filters/date-format';
import byteUnit from '@/plugins/filters/byte-unit';
export default (function () {
    Vue.filter('dateFormat', dateFormat);
    Vue.filter('byteUnit', byteUnit);
});
